import { render, staticRenderFns } from "./AdvertiserManageRead.vue?vue&type=template&id=4886c35b&scoped=true&"
import script from "./AdvertiserManageRead.vue?vue&type=script&lang=js&"
export * from "./AdvertiserManageRead.vue?vue&type=script&lang=js&"
import style0 from "./AdvertiserManageRead.vue?vue&type=style&index=0&id=4886c35b&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4886c35b",
  null
  
)

export default component.exports